<template>
  <span>
    <el-select
      :placeholder="placeholder"
      v-model="svalue"
      :clearable="clearable"
      filterable
      multiple
      collapse-tags
      :disabled="disabled"
    >
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="bindLabel(item)"
        :value="bindValue(item)"
      ></el-option>
    </el-select>
  </span>
</template>

<script>
export default {
  data() {
    return {
      svalue: this.objSelect,
      tindex: "",
    };
  },
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    optionBind: {
      type: Object,
      default: () => {
        return {
          label: "value",
          value: "key"
        };
      },
    },
    objSelect: {
      type: Array,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
    },
  },
  watch: {
    svalue(newVal, oldVal) {
      //console.log("11--", newVal);
      if (newVal !== oldVal) {
        this.$emit("changeSelct", this.svalue);
      }
    },
    objSelect(newVal, oldVal) {
      //console.log("222--", newVal, oldVal);
      if (newVal !== oldVal) {
        this.svalue = newVal;
      }
    },
  },
  methods: {
    bindLabel(item) {
      let tlabel = this.optionBind.label;
      return item[tlabel];
    },
    bindValue(item) {
      let tvalue = this.optionBind.value;
        return item[tvalue];
    },
  },
};
</script>
